export { default } from './Instagram.tsx'
